import { SiteEnum } from '../../models/enums/SiteEnum';
import { ISite } from './ISite';

export class SiteNaturfagsmaraton implements ISite {        
    backgroundImageName: string = 'logo_graa_pile.png';
    redirectTilNvHus: boolean = true;
    kortNavn: string = 'NFM';
    navn: string = 'Naturfagsmaraton';
    type: SiteEnum = SiteEnum.Naturfagsmaraton;
    logoName: string = 'nfm-logo.png';
    stortLogoName: string = 'lilla_pile.png';    
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/site/SiteNaturfagsmaraton.ts